
export const FeatureNameMap = {
  Multilungual: 'multilingual',
} as const;

export type FeatureName = typeof FeatureNameMap[keyof typeof FeatureNameMap];

export interface FeatureFlags {
  [key: string]: boolean;
}